export default {"src":"/_next/static/media/tether.d5dee556.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};